import React from "react";

import * as S from "./styles";

function SolutionCard({ title, problem, solution, isLast, image, id }) {
  return (
    <>
      <S.Divider />
      <S.CardWrapper $isLast={isLast}>
        <S.ContentContainer>
          <S.Title>
            {title}
            <S.TitleDot src="/images/icons/dot-orange.svg" alt="dot" />
          </S.Title>
          <S.DetailsContainer>
            {/* Image is now hidden */}
            <S.Image src={image} alt={`${id} image`} />
            <S.ProblemSection>
              <S.SectionHeader>
                <S.IconContainer>
                  <S.Icon
                    src="/images/tailored-solutions/problem.svg"
                    alt="Challenges Icon"
                  />
                </S.IconContainer>
                <S.SectionHeaderText>Challenges</S.SectionHeaderText>
              </S.SectionHeader>
              <S.ProblemText>{problem}</S.ProblemText>
            </S.ProblemSection>
            <S.DividerBlock />
            <S.SolutionSection>
              <S.SolutionHeader>
                <S.IconContainer>
                  <S.Icon
                    src="/images/tailored-solutions/solution.svg"
                    alt="Solution icon"
                  />
                </S.IconContainer>
                <S.SolutionHeaderText>Reach Solutions</S.SolutionHeaderText>
              </S.SolutionHeader>
              <S.SolutionText>{solution}</S.SolutionText>
            </S.SolutionSection>
          </S.DetailsContainer>
        </S.ContentContainer>
      </S.CardWrapper>
      {isLast && <S.Divider />}
    </>
  );
}

export default SolutionCard;
